import LegalMarkdown from "@/components/LegalMarkdown";
import LegalPageLayout from "@/components/LegalPageLayout";
import { PRIVACY_POLICY_BODY } from "@/content/privacy-policy";

export default function PrivacyPage() {
  return (
    <LegalPageLayout title="Privacy Policy" lastUpdated="May 26, 2026">
      <LegalMarkdown source={PRIVACY_POLICY_BODY} />
    </LegalPageLayout>
  );
}
